<template>
    <v-card>
        <v-card-title class="text-h5">
            <p>
                It's Not Possible To Delete.
            </p>
        </v-card-title>

        <v-card-text>
            The {{ partNumbers.length >= 2 ? 'part numbers ' : 'part number '
            }}<span class="font-weight-bold">{{ partNumbers.join(',') }}</span>
            have suggested quantity in the next packing lists:
            <v-data-table
                :headers="headers"
                :items="suggestedQtyAlerts"
                :sort-by="['partNumber', 'code']"
                class="mt-3 elevation-0"
                disable-pagination
                hide-default-footer
            >
            </v-data-table>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeDialog" text color="secondary" rounded>
                Accept
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'SuggestedQuantityDialog',
    props: {
        selectedItem: {
            type: Object,
            required: true,
        },
        suggestedQtyAlerts: {
            type: Array,
            required: true,
        },
    },
    data: () => ({
        headers: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
                width: 50,
            },
            {
                text: 'CODE',
                value: 'code',
                align: 'center',
                sortable: false,
                width: 50,
            },
            {
                text: 'SUGGESTED QUANTITY',
                value: 'value',
                align: 'center',
                sortable: false,
                width: 50,
            },
        ],
        partNumbers: [],
    }),
    mounted() {
        if (this.suggestedQtyAlerts.length > 0) {
            this.suggestedQtyAlerts.forEach(item => {
                // dont repeat part numbers
                if (!this.partNumbers.includes(item.partNumber)) {
                    this.partNumbers.push(item.partNumber)
                }
            })
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog')
        },
    },
}
</script>
